import React, { useState } from 'react';

const Testimonios = () => {
  const testimonios = [
    {
      nombre: "María López",
      rol: "Escritora y Activista",
      texto: "Gracias a Invision, pude acceder a libros que antes eran inalcanzables para mí. Su tecnología ha transformado mi vida.",
      imagen: "https://via.placeholder.com/100", // Reemplaza con una URL real
    },
    {
      nombre: "Carlos Ramírez",
      rol: "Estudiante Universitario",
      texto: "Los audiolibros me permitieron continuar mis estudios sin barreras. ¡Invision es increíble!",
      imagen: "https://via.placeholder.com/100", // Reemplaza con una URL real
    },
    {
      nombre: "Ana Gómez",
      rol: "Madre y Educadora",
      texto: "Como madre de un niño con discapacidad visual, estoy agradecida por el acceso a recursos tan valiosos.",
      imagen: "https://via.placeholder.com/100", // Reemplaza con una URL real
    },
  ];

  const [indiceActual, setIndiceActual] = useState(0);

  const siguienteTestimonio = () => {
    setIndiceActual((prev) => (prev + 1) % testimonios.length);
  };

  const anteriorTestimonio = () => {
    setIndiceActual((prev) => (prev - 1 + testimonios.length) % testimonios.length);
  };

  return (
    <div id="testimonios" className="mb-10 min-h-screen bg-slate-900 flex flex-col items-center justify-center text-white px-4">
      {/* Título principal */}
      <h1 className="text-5xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-600">
        Historias que Inspiran
      </h1>
      {/* Descripción general */}
      <p className="text-lg text-purple-300 text-center max-w-2xl mb-8">
        Escucha las voces de quienes han encontrado nuevas oportunidades gracias a Invision. Sus historias son el corazón de nuestro propósito.
      </p>
      {/* Carrusel de testimonios */}
      <div className="relative w-full max-w-2xl bg-slate-800 rounded-xl p-8 border border-purple-400/30 overflow-hidden">
        {/* Botón izquierdo */}
        <button
          onClick={anteriorTestimonio}
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-purple-600 text-white rounded-full p-2 hover:bg-purple-700 transition-all duration-300"
        >
          &#10094;
        </button>
        {/* Contenido del testimonio */}
        <div className="text-center">
          <h3 className="text-xl font-semibold text-purple-400 mb-2">
            {testimonios[indiceActual].nombre}
          </h3>
          <p className="text-sm text-purple-300 mb-4">
            {testimonios[indiceActual].rol}
          </p>
          <p className="text-purple-200 text-lg italic">
            "{testimonios[indiceActual].texto}"
          </p>
        </div>
        {/* Botón derecho */}
        <button
          onClick={siguienteTestimonio}
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-purple-600 text-white rounded-full p-2 hover:bg-purple-700 transition-all duration-300"
        >
          &#10095;
        </button>
      </div>
      {/* Llamado a la acción */}
      <div className="mt-12 text-center">
        <p className="text-purple-300 text-lg mb-4">
          ¿Quieres compartir tu historia? Únete a nuestra comunidad hoy.
        </p>
        <button className="px-8 py-3 bg-purple-600 text-white rounded-full hover:bg-purple-700 transition-all duration-300">
          Compartir mi historia
        </button>
      </div>
    </div>
  );
};

export default Testimonios;